import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js';
import { View } from 'backbone';
import listService from 'ListService.js';
import labelTemplate from 'properties/main/progress.ejs';


class MainProgressView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = labelTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            //'change #autoValue': 'togglePageProgress'
            //'change #progressValue': 'updateProgressValue'
        };

        // Add needed property
        if (this.model.get('autoValue') === undefined) {
            this.model.set('autoValue', true, {silent: true});
        }
        if (!this.model.get('value')) {
            this.model.set('value', '0', {silent: true});
        }      
        
        this.listenTo(this.model, 'change', this.render);        
        return this;
    }

    togglePageProgress(ev) {
        ev.preventDefault();
        const propName = 'autoValue';
        const propVal = ev.target.checked;
        if (propVal) {
            var newModel = {
                autoValue: propVal,
                value: '0'
            };
            this.model.set(newModel);
        }
        else {
            this.model.set(propName, propVal);
        }       
    }

    updateProgressValue(ev) {
        ev.preventDefault();
        const propName = 'value';
        const propVal = ev.target.value;
        let val = propVal ;
        if(Number(val) > 100){
           val = 100;
           $('#progressValue').val(val);
        }else if(Number(val) < 0){
           val = 0;
           $('#progressValue').val(val);
        }
        this.model.set(propName, val);
    }

    updateProgressBar(){
        if (this.model.attributes.autoValue){
            let pageCount= listService.pageCount;
            let currentPage= listService.getPage(listService.currentPageId);         
        
           if(currentPage.model.attributes.pageNumber === 1){
               this.model.set('value', '0', {silent: true}); 
           }else{
               let percentagePerPage = parseInt(100 / pageCount);
               let perAssign = (currentPage.model.attributes.pageNumber -1) * percentagePerPage;
               this.model.set('value', perAssign.toString()); 
           }
        }
    }

    render() {
        this.updateProgressBar();
        let self = this;
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bAutoValue = util.isTrue(this.model.get('autoValue'));
        $(`input[name='autoValue']`).prop('checked', bAutoValue );

        if (util.isTrue(this.model.get('autoValue')) ) {
            $('#progressValue').prop('disabled',true);
        } else {
            $('#progressValue').attr('disabled',false);
        }

        if (this.config.hideTitle) {
            $('#progressTitle').addClass('hide');
        }

        $('#progressValue').on('change', function (e) {
            self.updateProgressValue(e);
        });

        $('#autoValue').on('change', function (e) {
            self.togglePageProgress(e);
        });

        this.delegateEvents();
        return this;
    }

}

export default MainProgressView;
